import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import styles from './Contact.module.css';
import Menu from '../../containers/Menu/Menu';

import logo from '../../images/CVE_logo_shadow.svg';

export default class Contact extends Component {
  render() {
    return (
      <div className={styles.Contact}>
        <Menu strokeColor="#000" />
        <div className={styles.nav}>
          <div className={styles.left}>
            <Link to="/">
              <img src={logo} alt="logo" />
            </Link>
          </div>
          <div className={styles.right}>
            {/* <div>
              {
                [...Array(4)].map((_, index) => {
                  if (index === (indicator - 1)) {
                    return <div key={index} style={{ width: '15px', transition: 'width 0.1s ease-out' }} />
                  } else {
                    return <div key={index} />
                  }
                })
              }
            </div> */}
          </div>
        </div>
        <section className={styles.formWrapper}>
          <div className={styles.imgWrapperLeft}>
            <div className={styles.address}>
              <p className={styles.addressItem}>
                CVE FARMS <br /><br /> NIGERIA <br /> No. 100 Future Road <br /> #23-01,02,03 <br /> 123 Center Lagos 012334 <br /> Tel: +12 3456-3222
              </p>
              <p className={styles.addressItem}>ENGLAND <br /> London 1 street <br /> 02-100 Kentucky Lane <br /> Redwood <br /> Tel: +23 3-6300-2480</p>
            </div>
          </div>
          <form>
            <div>
              <h1>Contact Us</h1>
              <p>WHAT DO YOU WANT TO CONTACT US ABOUT ?</p>
              <label htmlFor="name">
                <p>
                  NAME
                </p>
                <input type="text" name="name" id="name" />
              </label>
              <label htmlFor="email">
                <p>
                  EMAIL
                </p>
                <input type="email" name="email" id="email" />
              </label>
              <label htmlFor="subject">
                <p>
                  SUBJECT
                </p>
                <input type="text" name="subject" id="subject" />
              </label>
              <label htmlFor="message">
                <p>
                  MESSAGE
                </p>
                <textarea name="message" id="message" />
              </label>
              <button>SEND MESSAGE</button>
            </div>
          </form>
        </section>
      </div>
    )
  }
}
